export const logError = (e: any) => {
  console.error(e);
};
